class SubscriptionRouterModalsContainer implements ng.IComponentController {
}

angular.module('animatronApp.SubscriptionRouterModalsContainer', [])
    .component('subscriptionRouterModalsContainer', {
        controller: SubscriptionRouterModalsContainer,
        templateUrl: require('settings/subscription/containers/subscription-router-modals-container.html')
    });



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/subscription/containers/SubscriptionRouterModalsContainer.ts